import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dev",
  "use": "dev-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dev\"><g fill-rule=\"evenodd\"><path d=\"M1 3c0-.552.445-1 .993-1h16.014c.548 0 .993.445.993 1v14c0 .552-.445 1-.993 1H1.993A.995.995 0 0 1 1 17V3Zm1 0h16v14H2V3Z\" /><path d=\"M10.857 8.313V7L16 11.5 10.857 16v-1.313L14.5 11.5l-3.643-3.188ZM9 6.313V5L3.857 9.5 9 14v-1.313L5.357 9.5 9 6.312Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol